import React from "react";
import { Container, Grid } from "@material-ui/core";
import HomePage from "../../Home";
import GCalendario from "./../GCalendario";
import { VCalendarioStyle } from "./styles";

export default function VProveedorUsuario() {
 const classes = VCalendarioStyle();
  return (
    <HomePage>
      <Container>
        <Grid container>
          <Grid item xs={12}>
            <div className={classes.contentMargin}>
              <GCalendario />
            </div>
          </Grid>
        </Grid>
      </Container>
    </HomePage>
  );
}
